import { useNavigate } from 'react-router-dom';
import { authService } from '../api';
import { useApi } from './useApi';

export const useResetPassword = () => {
  const navigate = useNavigate();

  const { loading, error, execute } = useApi({
    successMessage:
      'Password reset successfully! You can now login with your new password.',
    showSuccessToast: true,
    showErrorToast: true,
    onSuccess: () => {
      setTimeout(() => {
        navigate('/');
      }, 2000);
    },
  });

  const resetPassword = async (token: string, newPassword: string) => {
    return execute(() => authService.resetPassword(token, newPassword));
  };

  return {
    resetPassword,
    loading,
    error,
  };
};
